/**
 * TM Cart Opener v5
 * Subscribes to Dawn's real cartUpdate PubSub event (from pubsub.js)
 * so the drawer opens after any add-to-cart, including product pages.
 */
(function () {
  'use strict';

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.remove('is-empty');
      drawer.setAttribute('aria-hidden', 'false');
    }
  }

  function subscribeToDawn() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        // Only auto-open when the add came from a product form (not drawer qty changes)
        if (event && event.source === 'product-form') {
          setTimeout(openCartDrawer, 250);
        }
      });
    } else {
      setTimeout(subscribeToDawn, 400);
    }
  }

  // Fallback DOM events (harmless if never fired)
  document.addEventListener('cart:refresh', function () { setTimeout(openCartDrawer, 200); });
  document.addEventListener('product-added-to-cart', function () { setTimeout(openCartDrawer, 200); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', subscribeToDawn);
  } else {
    subscribeToDawn();
  }
})();
